(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('DiscountReason', DiscountReason);

    DiscountReason.$inject = ['$resource'];

    function DiscountReason ($resource) {
        var resourceUrl =  'api/discount-reasons/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
